"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _reactIntl = require("react-intl");

var _skuSelectorMessages = require("../skuSelectorMessages");

var Spinner = _reactComponents.shapes.Spinner;
var textFieldStyle = {
  minHeight: '100px',
  maxHeight: '300px',
  resize: 'vertical'
};
var initialState = {
  skus: '',
  loading: false,
  error: false,
  serviceError: null
};

var SkuUploadModal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SkuUploadModal, _PureComponent);

  function SkuUploadModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SkuUploadModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SkuUploadModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = initialState;

    _this.onChangeSkus = function (e) {
      var skus = e.target.value;

      _this.setState({
        skus: skus
      });
    };

    _this.onClose = function () {
      var onClose = _this.props.onClose;

      _this.setState(initialState);

      onClose();
    };

    _this.onAddSkus = function () {
      _this.setState({
        loading: true
      });

      var skus = _this.state.skus;
      var bulkAddSkus = _this.props.bulkAddSkus;

      if (!bulkAddSkus) {
        return;
      }

      var parsedSkus = _this.parseSkusToArray(skus);

      bulkAddSkus(parsedSkus).then(function (errors) {
        if (errors instanceof Error) {
          _this.setState({
            serviceError: errors,
            loading: false
          });

          return;
        }

        if (errors && errors.length) {
          _this.setState({
            error: true,
            skus: errors.join('\n'),
            loading: false
          });
        } else {
          _this.setState(initialState);

          _this.onClose();
        }
      });
    };

    _this.onRemoveSkus = function () {
      var skus = _this.state.skus;
      var bulkRemoveSkus = _this.props.bulkRemoveSkus;

      if (!bulkRemoveSkus) {
        return;
      }

      var parsedSkus = _this.parseSkusToArray(skus);

      var errors = bulkRemoveSkus(parsedSkus);

      if (errors.length) {
        _this.setState({
          error: true,
          skus: errors.join('\n')
        });

        return;
      }

      _this.setState(initialState);

      _this.onClose();
    };

    _this.parseSkusToArray = function (skusString) {
      return skusString.replace(/[,\n]+/g, ' ').split(' ').filter(function (sku) {
        return sku;
      });
    };

    return _this;
  }

  (0, _createClass2.default)(SkuUploadModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          add = _this$props.add,
          customBulkErrorMessage = _this$props.customBulkErrorMessage,
          formatMessage = _this$props.intl.formatMessage;
      var _this$state = this.state,
          skus = _this$state.skus,
          error = _this$state.error,
          serviceError = _this$state.serviceError,
          loading = _this$state.loading;
      var disabled = loading || skus.length === 0;
      var title = add ? formatMessage(_skuSelectorMessages.uploadModalMessages.addTitle) : formatMessage(_skuSelectorMessages.uploadModalMessages.removeTitle);
      var errorText;

      if (!add) {
        errorText = formatMessage(_skuSelectorMessages.uploadModalMessages.removeSkuError);
      } else if (customBulkErrorMessage) {
        errorText = customBulkErrorMessage;
      } else {
        errorText = formatMessage(_skuSelectorMessages.uploadModalMessages.addSkuError);
      }

      var defaultText = formatMessage(_skuSelectorMessages.uploadModalMessages.helpText);
      var skusArray = this.parseSkusToArray(skus);
      var footer = add ? _react.default.createElement("div", null, _react.default.createElement(_reactComponents.Button, {
        type: "primary",
        disabled: disabled,
        onClick: this.onAddSkus
      }, loading ? _react.default.createElement(Spinner, {
        size: 12,
        duration: 1.5
      }) : formatMessage(_skuSelectorMessages.uploadModalMessages.addButtonText, {
        totalCount: skusArray.length
      })), _react.default.createElement(_reactComponents.Button, {
        type: "default",
        onClick: this.onClose
      }, formatMessage(_skuSelectorMessages.uploadModalMessages.closeButtonText))) : _react.default.createElement("div", null, _react.default.createElement(_reactComponents.Button, {
        type: "primary",
        disabled: disabled,
        onClick: this.onRemoveSkus
      }, loading ? _react.default.createElement(Spinner, {
        size: 12,
        duration: 1.5
      }) : formatMessage(_skuSelectorMessages.uploadModalMessages.removeButtonText, {
        totalCount: skusArray.length
      })), _react.default.createElement(_reactComponents.Button, {
        type: "default",
        onClick: this.onClose
      }, formatMessage(_skuSelectorMessages.uploadModalMessages.closeButtonText)));
      return _react.default.createElement(_reactComponents.Modal, {
        show: show,
        closeButton: true,
        closeOnOutsideClick: true,
        title: title,
        onRequestHide: this.onClose,
        footer: footer
      }, _react.default.createElement(_reactComponents.TextField, {
        value: skus,
        type: "textarea",
        label: formatMessage(_skuSelectorMessages.uploadModalMessages.skuLabel),
        inputStyle: textFieldStyle,
        onChange: this.onChangeSkus,
        bsStyle: error ? 'error' : null,
        helpText: error ? errorText : defaultText
      }), serviceError ? _react.default.createElement("p", {
        className: "sku-modal-text"
      }, serviceError.message) : null);
    }
  }]);
  return SkuUploadModal;
}(_react.PureComponent);

var _default = (0, _reactIntl.injectIntl)(SkuUploadModal);

exports.default = _default;